import BackButton from 'components/BackButton';
import PageTitle from 'components/PageTitle';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AlternativeEntryMethod from 'components/enter/AlternativeEntryMethod';
import MainLayout from 'components/layout/MainLayout';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import Router from 'next/router';

const AlternativeEntryMethodPage = () => {
  /*
  const handleOngoingFunnelTrackingVariant = async () => {
    const variant = localStorage.getItem(
      `${SplitTest.OngoingFunnelTracking}_VARIANT`,
    );
    if (variant) {
      await trackFunnelEventIfHaveNotAlready(
        SplitTest.OngoingFunnelTracking,
        FunnelFlags.VisitedPostalEntryPage,
        variant,
        null,
      );
    }
  };

  useEffect(() => {
    (async () => {
      await handleOngoingFunnelTrackingVariant();
    })();
  }, []);
  */

  return (
    <MainLayout limitItemWidths>
      <NextSeo
        title="Alternative Entry Method | DAYMADE"
        description="Learn how to enter our draws via post"
        openGraph={{
          title: 'Alternative Entry Method | DAYMADE',
          description: 'Learn how to enter our draws via post',
        }}
      />

      <PageTitle rebrandDm2025>
        <strong>Postal</strong> Entry Method
      </PageTitle>

      <AboutUsModule background="white">
        <AboutUsSiteContainer>
          <div
            className="daymadeTypographyReset"
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <BackButton onClick={() => Router.back()} />

            <AlternativeEntryMethod />

            <BackButton onClick={() => Router.back()} />
          </div>
        </AboutUsSiteContainer>
      </AboutUsModule>
    </MainLayout>
  );
};

export const getServerSideProps: GetServerSideProps<
  Record<string, never>
> = async () => {
  return {
    props: {},
  };
};

export default AlternativeEntryMethodPage;
